import { hsaOrderContext } from "@redotech/redo-conversion-hsa-common/hsa-order-context";
import { unaryRpc } from "@redotech/rpc/definition";
import * as z from "zod/v4";
import { hsaSessionState } from "./types";

// First call on portal page load. Returns the current state plus
// session-level data the client needs to render its chrome (order summary,
// completion redirect). Reload-resume comes from the server walking the
// flow against the stored answer set every time — no client cursor.
export const getCurrentHsaGroup = unaryRpc({
  name: "getCurrentHsaGroup",
  input: z.object({ sessionToken: z.string().uuid() }),
  output: z.object({
    state: hsaSessionState,
    orderContext: hsaOrderContext,
    completedRedirectUrl: z.string().url(),
  }),
});
